<template>
  <div class="countdown-timer">
    <div class="countdown-timer__item" v-if="days">
      <div class="countdown-timer__item-label">days</div>
      <div class="countdown-timer__item-value">{{ days }}</div>
    </div>
    <div class="countdown-timer__item">
      <div class="countdown-timer__item-label">hrs</div>
      <div class="countdown-timer__item-value">
        {{ hours }}
      </div>
    </div>
    <div class="countdown-timer__item">
      <div class="countdown-timer__item-label">mins</div>
      <div class="countdown-timer__item-value">
        {{ minutes }}
      </div>
    </div>
    <div class="countdown-timer__item">
      <div class="countdown-timer__item-label">secs</div>
      <div class="countdown-timer__item-value">
        {{ seconds }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CountdownTimer",
  props: {
    value: [String, Date],
  },
  data() {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      interval: null,
    };
  },
  created() {
    this.startCountdown();
  },
  methods: {
    startCountdown() {
      this.calc();

      this.interval = setInterval(() => {
        this.calc();
      }, 1000);
    },
    calc() {
      const release = this.$moment(this.value);
      const today = this.$moment(new Date());
      const diff = release.diff(today);
      const duration = this.$moment.duration(diff, "milliseconds");

      const days = duration.days();
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();

      if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
        this.$emit("update");
      }

      this.days = days;
      this.hours = hours < 10 ? "0" + hours : hours;
      this.minutes = minutes < 10 ? "0" + minutes : minutes;
      this.seconds = seconds < 10 ? "0" + seconds : seconds;
    },
  },
  beforeDestroy() {
    if (this.interval) clearInterval(this.interval);
  },
};
</script>

<style scoped lang="scss">
.countdown-timer {
  display: flex;
  align-items: center;

  &__item {
    width: 60px;
  }

  &__item {
    text-align: center;
  }
  &__item-label {
    font-weight: 500;
    font-size: 20px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    line-height: 22px;
  }
  &__item-value {
    font-weight: normal;
    font-size: 40px;
    text-align: center;
    text-transform: uppercase;
    color: #ffffff;
    line-height: 1;
  }
}

@media screen and (max-width: 700px) {
  .countdown-timer {
    margin: 15px 0;
    height: 60px;
    padding: 15px 0;

    &__item {
      margin: 0 10px;
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 55px;

      &-value {
        font-size: 3em;
        line-height: 1;
      }
      &-label {
        margin: 0 10px;
        font-size: 1em;
      }
    }
  }
}
</style>
